// import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
// import React, { useState } from 'react';
// import { Button } from 'reactstrap';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import './RemainingAmountCard.css';
// import { changeDateFormate } from 'src/utils/dateutils';

// const initialFormValidation = {
//   paymentTypeValidation: false,
//   amountExceedValidation: false,
// };

// const RemainingAmountCard = ({
//   data,
//   clientNumber,
//   setClientMembership,
//   setSelectedClient,
//   setClientCoupons,
//   allCouponsData,
//   selectedClient,
// }) => {
//   const { clearRemainingAmount, activeBranchId, fetchClientByNumber, setShowMessage } = useMain();
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [ContinueBill, setContinueBill] = useState({});
//   const [paymentLoading, setPaymentLoading] = useState(false);
//   const [remainingAmountBillLoading, setRemainingAmountBillLoading] = useState(false);
//   const [formValidation, setFormValidation] = useState(initialFormValidation);

//   const [formData, setFormData] = useState({
//     amount: '',
//     paymentType: '',
//   });

//   const paymentTypeValidation = !formData.paymentType;

//   const handleOpenDialogue = (bill) => {
//     setContinueBill(bill);
//     // Set the initial amount to the pending amount instead of empty string
//     setFormData((pre) => ({ ...pre, amount: bill.newPaidDues.toString(), paymentType: '' }));
//     setOpenDialogue(true);
//   };

//   const handleCloseDialogue = () => {
//     setContinueBill({});
//     setFormValidation((pre) => ({ ...pre, paymentTypeValidation: false }));
//     setFormData((pre) => ({ ...pre, amount: '', paymentType: '' }));
//     setOpenDialogue(false);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     // For amount field, keep it as string for display but convert to number when needed
//     if (name === 'amount') {
//       // Only allow numbers and decimal point
//       const numericValue = value.replace(/[^0-9.]/g, '');
//       // Prevent multiple decimal points
//       const sanitizedValue = numericValue.replace(/(\..*)\./g, '$1');
      
//       setFormData((pre) => {
//         const updatedForm = { ...pre, [name]: sanitizedValue };

//         const validation = {
//           amountValidation:
//             !updatedForm.amount ||
//             isNaN(parseFloat(updatedForm.amount)) ||
//             parseFloat(updatedForm.amount) > ContinueBill.newPaidDues ||
//             parseFloat(updatedForm.amount) <= 0,
//         };

//         setFormValidation(validation);

//         return updatedForm;
//       });
//     } else {
//       setFormData((pre) => ({ ...pre, [name]: value }));
//     }
//   };

//   const handlePaymentSubmit = async () => {
//     const { paymentType, amount } = formData;
//     const amountNum = parseFloat(amount);

//     if (paymentType === 'Wallet' && selectedClient?.advancedGiven < amountNum) {
//       setShowMessage({
//         message: 'Insufficient wallet balance to pay the dues.',
//         messageType: 'error',
//       });
//       return;
//     }

//     const validation = {
//       paymentTypeValidation: !paymentType,
//       amountValidation:
//         !amount ||
//         isNaN(amountNum) ||
//         amountNum > ContinueBill.newPaidDues ||
//         amountNum <= 0,
//     };

//     setFormValidation((pre) => ({ ...pre, ...validation }));

//     if (Object.values(validation).some((item) => item)) return;

//     setPaymentLoading(true);

//     try {
//       const res = await clearRemainingAmount(
//         ContinueBill.billId,
//         `?branchId=${activeBranchId}`,
//         {
//           remainingAmount: {
//             amount: amountNum, // Ensure we're sending a number
//             paymentType: formData.paymentType,
//             billType: ContinueBill.billType === "" ? "Bill" : ContinueBill.billType,
//           },
//         }
//       );

//       if (res.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Payment Status Success',
//           messageType: 'success',
//         });
//         handleCloseDialogue();
//         getClinet(clientNumber);
//       } else {
//         setShowMessage({
//           message: res.message || 'Payment Status Failed',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: 'Something went wrong please try after some time',
//         messageType: 'error',
//       });
//     } finally {
//       setPaymentLoading(false);
//     }
//   };

//   const getClinet = async (clientNumber) => {
//     setRemainingAmountBillLoading(true);
//     try {
//       const res = await fetchClientByNumber(clientNumber, activeBranchId);
//       if (res.statusCode === 200) {
//         const client = res?.data;
//         setSelectedClient(client);
//         setClientMembership(checkMembershipValidation(client.membershipDetails));
//         setClientCoupons(filterClinetsCoupons(allCouponsData, res?.data?.coupons));
//       }
//     } catch (error) {
//       // Handle error
//     } finally {
//       setRemainingAmountBillLoading(false);
//     }
//   };

//   // Check if wallet should be disabled based on bill type
//   const isWalletDisabled = 
//     formData.paymentType === 'Wallet' && 
//     (selectedClient?.advancedGiven < parseFloat(formData.amount) || 
//      ContinueBill.billType === 'Membership' || 
//      ContinueBill.billType === 'Package');

//   // Function to render bill type specific columns
//   const renderBillTypeColumns = (bill) => {
//     switch(bill.billType) {
//       case 'Membership':
//         return (
//           <>
//             <td style={{ width: '100%' }}>Membership</td>
//           </>
//         );
//       case 'Package':
//         return (
//           <>
//             <td style={{ width: '100%' }}>Package</td>
//           </>
//         )
//         case 'Wallet':
//         return (
//           <>
//             <td style={{ width: '100%' }}>Wallet</td>
//           </>
//         );
//       default:
//         return (
//           <>
//             <td style={{ width: '100%' }}>Bill</td>
//           </>
//         );
//     }
//   };

//   return (
//     <div className="container">
//       {remainingAmountBillLoading ? (
//         <ShowLoader />
//       ) : (
//         <table className="table-container mt-3">
//           <thead className="table-thead">
//             <tr>
//               {['Date of Bill', 'Bill Type', 'Total', 'Paid', 'Pending', ''].map((h, index) => {
//                 return (
//                   <th key={index} style={{ width: '100%' }}>
//                     {h}
//                   </th>
//                 );
//               })}
//             </tr>
//           </thead>
//           <tbody className="table-tbody">
//             {data.map((bill) => (
//               <tr key={bill.billId}>
//                 <td style={{ width: '100%' }}>{changeDateFormate(bill?.dateOfBilling)}</td>
//                 {renderBillTypeColumns(bill)}
//                 <td style={{ width: '100%' }}>{bill?.payableAmount}</td>
//                 <td style={{ width: '100%' }}>{bill?.amountPaid}</td>
//                 <td style={{ width: '100%', color: 'red' }}>{bill?.newPaidDues}</td>
//                 <td
//                   style={{
//                     width: '100%',
//                     display: 'flex',
//                     justifyContent: 'flex-end',
//                   }}
//                 >
//                   <button
//                     style={{
//                       background: '#6174DD',
//                       color: 'white',
//                       padding: '4px 16px',
//                       border: 'none',
//                       borderRadius: '6px',
//                       cursor: 'pointer',
//                       fontSize: '17px',
//                       transition: 'background-color 0.3s ease',
//                     }}
//                     onClick={() => handleOpenDialogue(bill)}
//                   >
//                     Pay
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//       <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
//         <DialogTitle>Continue to Pay</DialogTitle>
//         <DialogContent>
//           <div className="container2">
//             {paymentLoading ? (
//               <ShowLoader />
//             ) : (
//               <div className="paymentBox">
//                 <div>
//                   <label htmlFor="amount">Amount: </label>
//                   <input
//                     type="text" // Changed from number to text to prevent browser auto-formatting
//                     id="amount"
//                     name="amount"
//                     value={formData.amount}
//                     onChange={handleChange}
//                     className={formValidation.amountValidation ? 'border border-danger' : ''}
//                     inputMode="decimal" // Shows numeric keyboard on mobile
//                   />
//                   {formValidation.amountValidation && (
//                     <div className="text-danger">Please enter a valid amount.</div>
//                   )}
//                 </div>
//                 <div>
//                   <label htmlFor="paymentType">Payment Method: </label>
//                   <select
//                     className={`paymentTypeSelect ${
//                       formValidation.paymentTypeValidation && paymentTypeValidation
//                         ? 'border border-danger'
//                         : ''
//                     }`}
//                     id="paymentType"
//                     name="paymentType"
//                     onChange={handleChange}
//                     value={formData.paymentType}
//                   >
//                     <option value="" disabled>
//                       --Select--
//                     </option>
//                     <option value="Cash">Cash</option>
//                     <option value="Credit/Debit Card">Credit/Debit card</option>
//                     <option value="Paytm">Paytm</option>
//                     <option value="PhonePe">PhonePe</option>
//                     <option value="Gpay">Gpay</option>
//                     <option 
//                       value="Wallet" 
//                       disabled={ContinueBill.billType === 'Membership' || ContinueBill.billType === 'Package' || ContinueBill.billType === 'Wallet'}
//                     >
//                       Wallet
//                     </option>
//                   </select>
//                   {formValidation.paymentTypeValidation && paymentTypeValidation && (
//                     <div className="text-danger">Please select a payment method</div>
//                   )}
//                   {isWalletDisabled && (
//                     <div className="text-danger">
//                       {ContinueBill.billType === 'Membership' || ContinueBill.billType === 'Package' 
//                         ? "Wallet payment not available for memberships/packages" 
//                         : "Your wallet amount is insufficient, please select another method"}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </DialogContent>
//         <DialogActions
//           sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}
//         >
//           <Button
//             variant="contained"
//             sx={{
//               width: '14%',
//             }}
//             onClick={handleCloseDialogue}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             color="primary"
//             sx={{
//               width: '18%',
//               background: '#6174DD',
//               cursor: isWalletDisabled ? 'not-allowed' : 'pointer',
//               opacity: isWalletDisabled ? 0.5 : 1,
//             }}
//             onClick={handlePaymentSubmit}
//             disabled={isWalletDisabled}
//           >
//             Pay
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default RemainingAmountCard;

// function isValidMembershipDetails(membershipDetails) {
//   if (
//     typeof membershipDetails === 'object' &&
//     membershipDetails.startDate &&
//     membershipDetails.endDate
//   ) {
//     const startDate = new Date(membershipDetails.startDate);
//     const endDate = new Date(membershipDetails.endDate);
//     const currentDate = new Date();

//     if (
//       !isNaN(startDate.getTime()) &&
//       !isNaN(endDate.getTime()) &&
//       currentDate >= startDate &&
//       currentDate <= endDate
//     ) {
//       return true;
//     }
//   }
//   return false;
// }

// function checkMembershipValidation(membershipDetails) {
//   return isValidMembershipDetails(membershipDetails) ? membershipDetails : {};
// }

// function filterClinetsCoupons(coupons, clientCoupons) {
//   const couponUsage = clientCoupons.reduce((acc, couponId) => {
//     acc[couponId] = (acc[couponId] || 0) + 1;
//     return acc;
//   }, {});

//   return coupons.filter((coupon) => {
//     const usedCount = couponUsage[coupon._id] || 0;
//     return coupon.couponPerUser > usedCount;
//   });
// }

import { Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import './RemainingAmountCard.css';
import { changeDateFormate } from 'src/utils/dateutils';
import { Box } from '@mui/system';
import { IoLogoWhatsapp } from "react-icons/io";
import { useNavigate } from 'react-router';

const initialFormValidation = {
  paymentTypeValidation: false,
  amountExceedValidation: false,
};

const RemainingAmountCard = ({
  data,
  clientNumber,
  setClientMembership,
  setSelectedClient,
  setClientCoupons,
  allCouponsData,
  selectedClient,
}) => {
  const { clearRemainingAmount, activeBranchId, fetchClientByNumber, setShowMessage } = useMain();
  const [openDialogue, setOpenDialogue] = useState(false);
  const [openSuccessDialogue, setOpenSuccessDialogue] = useState(false);
  const [ContinueBill, setContinueBill] = useState({});
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [remainingAmountBillLoading, setRemainingAmountBillLoading] = useState(false);
  const [formValidation, setFormValidation] = useState(initialFormValidation);
  const [createdBillId, setCreatedBillId] = useState(null);
  const [billType, setBillType] = useState('');
  
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    amount: '',
    paymentType: '',
    sendWhatsapp: true, // Default true as requested
  });

  const paymentTypeValidation = !formData.paymentType;

  const handleOpenDialogue = (bill) => {
    setContinueBill(bill);
    // Set the initial amount to the pending amount instead of empty string
    setFormData((pre) => ({ 
      ...pre, 
      amount: bill.newPaidDues.toString(), 
      paymentType: '',
      sendWhatsapp: true // Reset to default true when opening dialog
    }));
    setOpenDialogue(true);
  };

  const handleCloseDialogue = () => {
    setContinueBill({});
    setFormValidation((pre) => ({ ...pre, paymentTypeValidation: false }));
    setFormData((pre) => ({ ...pre, amount: '', paymentType: '', sendWhatsapp: true }));
    setOpenDialogue(false);
  };

  const handleCloseSuccessDialogue = () => {
    setOpenSuccessDialogue(false);
    setCreatedBillId(null);
    setBillType('');
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      setFormData((pre) => ({ ...pre, [name]: checked }));
      return;
    }
    
    // For amount field, keep it as string for display but convert to number when needed
    if (name === 'amount') {
      // Only allow numbers and decimal point
      const numericValue = value.replace(/[^0-9.]/g, '');
      // Prevent multiple decimal points
      const sanitizedValue = numericValue.replace(/(\..*)\./g, '$1');
      
      setFormData((pre) => {
        const updatedForm = { ...pre, [name]: sanitizedValue };

        const validation = {
          amountValidation:
            !updatedForm.amount ||
            isNaN(parseFloat(updatedForm.amount)) ||
            parseFloat(updatedForm.amount) > ContinueBill.newPaidDues ||
            parseFloat(updatedForm.amount) <= 0,
        };

        setFormValidation(validation);

        return updatedForm;
      });
    } else {
      setFormData((pre) => ({ ...pre, [name]: value }));
    }
  };

  const handlePaymentSubmit = async () => {
    const { paymentType, amount, sendWhatsapp } = formData;
    const amountNum = parseFloat(amount);

    if (paymentType === 'Wallet' && selectedClient?.advancedGiven < amountNum) {
      setShowMessage({
        message: 'Insufficient wallet balance to pay the dues.',
        messageType: 'error',
      });
      return;
    }

    const validation = {
      paymentTypeValidation: !paymentType,
      amountValidation:
        !amount ||
        isNaN(amountNum) ||
        amountNum > ContinueBill.newPaidDues ||
        amountNum <= 0,
    };

    setFormValidation((pre) => ({ ...pre, ...validation }));

    if (Object.values(validation).some((item) => item)) return;

    setPaymentLoading(true);

    try {
      const res = await clearRemainingAmount(
        ContinueBill.billId,
        `?branchId=${activeBranchId}`,
        {
          remainingAmount: {
            amount: amountNum, // Ensure we're sending a number
            paymentType: formData.paymentType,
            billType: ContinueBill.billType === "" ? "Bill" : ContinueBill.billType,
          },
          sendWhatsapp: formData.sendWhatsapp, // Pass WhatsApp status in payload
        }
      );

      if (res.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Payment Status Success',
          messageType: 'success',
        });
        
        // Store the bill ID and type for success dialog
        setCreatedBillId(res.data?.billId || ContinueBill.billId);
        setBillType(ContinueBill.billType || 'Bill');
        
        handleCloseDialogue();
        setOpenSuccessDialogue(true); // Open success dialog
        getClinet(clientNumber);
      } else {
        setShowMessage({
          message: res.message || 'Payment Status Failed',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: 'Something went wrong please try after some time',
        messageType: 'error',
      });
    } finally {
      setPaymentLoading(false);
    }
  };

  const handleViewBill = () => {
    if (createdBillId) {
      // Navigate to bill details page
      const billTypeLower = billType.toLowerCase();
      if (billTypeLower === 'package' || billTypeLower === 'membership') {
        navigate(`/billing/${createdBillId}`, {
          state: { ownerId: activeBranchId, billType: billTypeLower },
        });
      } else {
        navigate(`/billing/${createdBillId}`, { state: { ownerId: activeBranchId } });
      }
      handleCloseSuccessDialogue();
    }
  };

  const getClinet = async (clientNumber) => {
    setRemainingAmountBillLoading(true);
    try {
      const res = await fetchClientByNumber(clientNumber, activeBranchId);
      if (res.statusCode === 200) {
        const client = res?.data;
        setSelectedClient(client);
        setClientMembership(checkMembershipValidation(client.membershipDetails));
        setClientCoupons(filterClinetsCoupons(allCouponsData, res?.data?.coupons));
      }
    } catch (error) {
      // Handle error
    } finally {
      setRemainingAmountBillLoading(false);
    }
  };

  // Check if wallet should be disabled based on bill type
  const isWalletDisabled = 
    formData.paymentType === 'Wallet' && 
    (selectedClient?.advancedGiven < parseFloat(formData.amount) || 
     ContinueBill.billType === 'Membership' || 
     ContinueBill.billType === 'Package');

  // Function to render bill type specific columns
  const renderBillTypeColumns = (bill) => {
    switch(bill.billType) {
      case 'Membership':
        return (
          <>
            <td style={{ width: '100%' }}>Membership</td>
          </>
        );
      case 'Package':
        return (
          <>
            <td style={{ width: '100%' }}>Package</td>
          </>
        )
      case 'Wallet':
        return (
          <>
            <td style={{ width: '100%' }}>Wallet</td>
          </>
        );
      default:
        return (
          <>
            <td style={{ width: '100%' }}>Bill</td>
          </>
        );
    }
  };

  return (
    <div className="container">
      {remainingAmountBillLoading ? (
        <ShowLoader />
      ) : (
        <table className="table-container mt-3">
          <thead className="table-thead">
            <tr>
              {['Date of Bill', 'Bill Type', 'Total', 'Paid', 'Pending', ''].map((h, index) => {
                return (
                  <th key={index} style={{ width: '100%' }}>
                    {h}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody className="table-tbody">
            {data.map((bill) => (
              <tr key={bill.billId}>
                <td style={{ width: '100%' }}>{changeDateFormate(bill?.dateOfBilling)}</td>
                {renderBillTypeColumns(bill)}
                <td style={{ width: '100%' }}>{bill?.payableAmount}</td>
                <td style={{ width: '100%' }}>{bill?.amountPaid}</td>
                <td style={{ width: '100%', color: 'red' }}>{bill?.newPaidDues}</td>
                <td
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <button
                    style={{
                      background: '#6174DD',
                      color: 'white',
                      padding: '4px 16px',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: '17px',
                      transition: 'background-color 0.3s ease',
                    }}
                    onClick={() => handleOpenDialogue(bill)}
                  >
                    Pay
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      
      {/* Payment Dialog */}
      <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
        <DialogTitle>Continue to Pay</DialogTitle>
        <DialogContent>
          <div className="container2">
            {paymentLoading ? (
              <ShowLoader />
            ) : (
              <div className="paymentBox">
                <div>
                  <label htmlFor="amount">Amount: </label>
                  <input
                    type="text"
                    id="amount"
                    name="amount"
                    value={formData.amount}
                    onChange={handleChange}
                    className={formValidation.amountValidation ? 'border border-danger' : ''}
                    inputMode="decimal"
                  />
                  {formValidation.amountValidation && (
                    <div className="text-danger">Please enter a valid amount.</div>
                  )}
                </div>
                <div>
                  <label htmlFor="paymentType">Payment Method: </label>
                  <select
                    className={`paymentTypeSelect ${
                      formValidation.paymentTypeValidation && paymentTypeValidation
                        ? 'border border-danger'
                        : ''
                    }`}
                    id="paymentType"
                    name="paymentType"
                    onChange={handleChange}
                    value={formData.paymentType}
                  >
                    <option value="" disabled>
                      --Select--
                    </option>
                    <option value="Cash">Cash</option>
                    <option value="Credit/Debit Card">Credit/Debit card</option>
                    <option value="Paytm">Paytm</option>
                    <option value="PhonePe">PhonePe</option>
                    <option value="Gpay">Gpay</option>
                    <option 
                      value="Wallet" 
                      disabled={ContinueBill.billType === 'Membership' || ContinueBill.billType === 'Package' || ContinueBill.billType === 'Wallet'}
                    >
                      Wallet
                    </option>
                  </select>
                  {formValidation.paymentTypeValidation && paymentTypeValidation && (
                    <div className="text-danger">Please select a payment method</div>
                  )}
                  {isWalletDisabled && (
                    <div className="text-danger">
                      {ContinueBill.billType === 'Membership' || ContinueBill.billType === 'Package' 
                        ? "Wallet payment not available for memberships/packages" 
                        : "Your wallet amount is insufficient, please select another method"}
                    </div>
                  )}
                </div>

                {/* WhatsApp Checkbox */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  gap={3}
                  mb={0}
                  mt={2}
                >
                  <Typography>Bill Send On</Typography>

                  {/* WhatsApp Option */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="sendWhatsapp"
                        checked={formData.sendWhatsapp}
                        onChange={handleChange}
                        sx={{ color: '#6174DD' }}
                      />
                    }
                    label={
                      <Box display="flex" alignItems="center" gap={0.5} marginTop={'12px'}>
                        <IoLogoWhatsapp size={28} color="#0AAA15" />
                        <Typography style={{ color: 'black', fontWeight: '500' }}>WhatsApp</Typography>
                      </Box>
                    }
                  />
                </Box>
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}
        >
          <Button
            variant="contained"
            sx={{
              width: '14%',
            }}
            onClick={handleCloseDialogue}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              width: '18%',
              background: '#6174DD',
              cursor: isWalletDisabled ? 'not-allowed' : 'pointer',
              opacity: isWalletDisabled ? 0.5 : 1,
            }}
            onClick={handlePaymentSubmit}
            disabled={isWalletDisabled}
          >
            Pay
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success Dialog */}
      <Dialog open={openSuccessDialogue} onClose={handleCloseSuccessDialogue} maxWidth="sm">
        <DialogTitle sx={{ textAlign: 'center', color: 'green' }}>
          Payment Successful!
        </DialogTitle>
        <DialogContent>
          <Typography textAlign="center">
            Your payment has been processed successfully.
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '20px' }}
        >
          <Button
            variant="outlined"
            onClick={handleCloseSuccessDialogue}
            sx={{
              width: '120px',
            }}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              width: '120px',
              background: '#6174DD',
            }}
            onClick={handleViewBill}
          >
            View Bill
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RemainingAmountCard;

function isValidMembershipDetails(membershipDetails) {
  if (
    typeof membershipDetails === 'object' &&
    membershipDetails.startDate &&
    membershipDetails.endDate
  ) {
    const startDate = new Date(membershipDetails.startDate);
    const endDate = new Date(membershipDetails.endDate);
    const currentDate = new Date();

    if (
      !isNaN(startDate.getTime()) &&
      !isNaN(endDate.getTime()) &&
      currentDate >= startDate &&
      currentDate <= endDate
    ) {
      return true;
    }
  }
  return false;
}

function checkMembershipValidation(membershipDetails) {
  return isValidMembershipDetails(membershipDetails) ? membershipDetails : {};
}

function filterClinetsCoupons(coupons, clientCoupons) {
  const couponUsage = clientCoupons.reduce((acc, couponId) => {
    acc[couponId] = (acc[couponId] || 0) + 1;
    return acc;
  }, {});

  return coupons.filter((coupon) => {
    const usedCount = couponUsage[coupon._id] || 0;
    return coupon.couponPerUser > usedCount;
  });
}
